<div class="page-layout">
    <div *ngIf="showMismatchBanner" class="toast-container toast-msg__complete__error">
      <div class="toast-wrapper">
        <div class="f-row toaster-value-row">
          <div class="toast-icon">
            <mat-icon fontSet="material-symbols-outlined" class="mat-icon check-icon">info</mat-icon>
          </div>
          <div class="toast-content">
            <div class="toast-desc">
              <p>
                {{content?.['b2b.managecompany.emaildomainmismatch'] || 'Email domain mismatch. Please update employee emails to the new domain.'}}
                <a role="button" tabindex="0" (keydown.enter)="onReadMoreClick(domainUpdateIncompleteTemplate)" (click)="onReadMoreClick(domainUpdateIncompleteTemplate)">{{ content?.warningList?.[5]?.confirmCTAText }}</a>
              </p>
            </div>
          </div>
        </div>
        <div class="actions">
          <button type="button" class="button-as-span sort-close" (click)="dismissMismatchToast()">
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <form class="f-col blank-form" [formGroup]="form">
        <div class="section-heading">
            <h2 class="h2-heading">{{content?.['b2b.managecompany.omfchangeemaildomain'] || 'Change email domain'}}</h2>
            <button type="button" class="button-as-span link" aria-label="open dialog button" (click)="openModal()" *ngIf="hasDomain && !isDomainEditable">
                <mat-icon fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon>{{content?.['b2b.managecompany.cdedit'] || 'Edit'}}
            </button>
        </div>

        <div class="section-content">
            <div class="inner-contentsection">
                <app-cam-empty-state
                    *ngIf="!hasDomain && !showNoDomainEditor"
                    [disableNavigation]="true"
                    (myEvent)="openNoDomainInfoPopup(updateEmailDomainInfoTemplate)"
                    [heading]="content?.['b2b.managecompany.omfnodomaintitle'] || 'No domain configured'"
                    [content]="content?.['b2b.managecompany.omfnodomaindesc'] || 'Add domain for'">
                </app-cam-empty-state>

                 <div class="change-domain-row" *ngIf="hasDomain || showNoDomainEditor">
          <div class="domain-label">
            <p>{{ (hasDomain && !isDomainEditable) ? 'Current domain:' : 'New domain :' }}</p>
          </div>

          <div class="col-username">
            <p>{{content?.['b2b.managecompany.omfusername']}}</p>
          </div>

          <div class="domain-field-wrap">
            <mat-form-field appearance="fill" class="change-domain-mat-field">
              <input
                matInput
                formControlName="domain"
                autocomplete="off"
                [placeholder]="(!hasDomain || isDomainEditable) ? 'Enter domain' : ''"/>
              <mat-error *ngIf="form.get('domain')?.hasError('required') && (form.get('domain')?.touched || form.get('domain')?.dirty)">{{dictionaryContent?.['b2b.managecompany.domainrequired'] || 'Domain is required'}}</mat-error>
              <mat-error *ngIf="form.get('domain')?.hasError('pattern') && (form.get('domain')?.touched || form.get('domain')?.dirty)">{{dictionaryContent?.['b2b.managecompany.entervaliddomain'] || 'Enter a valid domain'}}</mat-error>
              <mat-error *ngIf="form.get('domain')?.hasError('domainExists') && (form.get('domain')?.touched || form.get('domain')?.dirty)">{{ form.get('domain')?.getError('domainExists') }}</mat-error>
            </mat-form-field>
          </div>
        </div>
            </div>
            <div class="inner-action" *ngIf="(hasDomain && isDomainEditable) || showNoDomainEditor">
                <button mat-button type="button" class="button--secondary-small" (click)="onEmailDomainCancel()">{{content?.['b2b.managecompany.cancel'] || 'Cancel'}}</button>
                <button
                  mat-button
                  type="button"
                  class="button--primary-small"
                  [disabled]="form.get('domain')?.invalid || !isDomainAcceptable || isDomainCheckLoading"
                  [class.button--disabled]="form.get('domain')?.invalid || !isDomainAcceptable || isDomainCheckLoading"
                  (click)="onEmailDomainSave()">
                    <!-- <mat-spinner class="button"></mat-spinner> -->
                    {{content?.['b2b.managecompany.save'] || 'Save'}}</button>
            </div>
        </div>
    </form>
</div>

<ng-template #updateEmailDomainInfoTemplate>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{ sitecoreGetWarningMessage('b2b.managecompany.omfupdateemployemailpopup')?.title || 'Update Employee Email Domains' }}</span>
      <mat-icon
        fontSet="material-symbols-outlined"
        class="close_icon"
        tabindex="0"
        role="button"
        aria-label="close button"
        (keyup.space)="closeNoDomainInfoPopup()"
        (keydown.enter)="closeNoDomainInfoPopup()"
        (click)="closeNoDomainInfoPopup()">
        close
      </mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <p>{{ sitecoreGetWarningMessage('b2b.managecompany.omfupdateemployemailpopup')?.subTitle || 'To proceed, please update all employees’ email addresses individually to the new domain.' }}</p>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button type="button" (click)="onNoDomainPopupContinue()">
        {{ sitecoreGetWarningMessage('b2b.managecompany.omfupdateemployemailpopup')?.confirmCTAText || 'Continue' }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #domainUpdateIncompleteTemplate>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{ sitecoreGetWarningMessage('b2b.managecompany.domainupdateincomplete')?.title || 'Domain update incomplete' }}</span>
    </div>
    <div class="custom-popup-gen-body">
      <p>{{ sitecoreGetWarningMessage('b2b.managecompany.domainupdateincomplete')?.description || 'We found that not all employees have updated their email addresses to the new domain. You can view the list of employees who still need to update their email domain.' }}</p>
    </div>
    <div class="custom-popup-gen-footer footer-with-secondary">
      <button class="button--secondary-small" mat-button type="button" (click)="closeDomainUpdateIncompletePopup()">
        {{ sitecoreGetWarningMessage('b2b.managecompany.domainupdateincomplete')?.cancelCTAText || 'Close' }}
      </button>
      <button class="button--primary-small" mat-button type="button" (click)="onMismatchViewClick(mismatchUsersTemplate)">
        {{ sitecoreGetWarningMessage('b2b.managecompany.domainupdateincomplete')?.confirmCTAText || 'View' }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #mismatchUsersTemplate>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managecompany.omflistofprofiles'] || 'The following profiles have a different domain'}}</span>
      <mat-icon
        fontSet="material-symbols-outlined"
        class="close_icon"
        tabindex="0"
        role="button"
        aria-label="close button"
        (keyup.space)="closeMismatchUsersPopup()"
        (keydown.enter)="closeMismatchUsersPopup()"
        (click)="closeMismatchUsersPopup()">
        close
      </mat-icon>
    </div>
    <div class="custom-popup-gen-body mismatch-users-body">
      <div class="mismatch-users-table-wrap">
        <table class="mismatch-users-table">
          <thead>
            <tr>
              <th>{{content?.['b2b.managecompany.omfemploycode'] || 'Employee Code'}}</th>
              <th>{{content?.['b2b.managecompany.omfemployname'] || 'Employee Name'}}</th>
              <th>{{content?.['b2b.managecompany.omfemployemail'] || 'Employee Email'}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of mismatchedUsers">
              <td>{{ user.employeeCode || '-' }}</td>
              <td>{{ getMismatchUserDisplayName(user) }}</td>
              <td>{{ user.emailAddress || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mismatch-users-pagination">
        <button
          class="button--secondary-small"
          mat-button
          type="button"
          [disabled]="mismatchUsersPageNumber <= 1 || mismatchUsersLoading"
          [class.button--disabled]="mismatchUsersPageNumber <= 1 || mismatchUsersLoading"
          (click)="onMismatchUsersPreviousPage()">
          {{dictionaryContent?.['b2b.booking.previouspage'] || 'Previous page'}}
        </button>
        <span>Page {{ mismatchUsersPageNumber }}</span>
        <button
          class="button--primary-small"
          mat-button
          type="button"
          [disabled]="!mismatchUsersHasNextPage || mismatchUsersLoading"
          [class.button--disabled]="!mismatchUsersHasNextPage || mismatchUsersLoading"
          (click)="onMismatchUsersNextPage()">
          {{ mismatchUsersLoading ? 'Loading...' : (content?.['b2b.booking.previouspage'] || 'Next page') }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #processingTemplate>
  <div class="custom-popup-gen-container processing-popup">
    <div class="custom-popup-gen-body processing-popup-body">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Please wait, this might take some time...</p>
    </div>
  </div>
</ng-template>

<ng-template #failedEmployeesTemplate>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managecompany.domainupdatepartialfail'] || 'Domain update failed for some employees'}}</span>
    </div>
    <div class="custom-popup-gen-body mismatch-users-body">
      <p>{{content?.['b2b.managecompany.employeesnotupdated'] || 'The following employees could not be updated. Please try again.'}}</p>
      <div class="mismatch-users-table-wrap">
        <table class="mismatch-users-table">
          <thead>
            <tr>
              <th>{{content?.['b2b.managecompany.omfemployemail'] || 'Employee Email'}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of failedEmployees">
              <td>{{ emp.employeeEmail || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button
        class="button--primary-small retry-btn"
        mat-button
        type="button"
        [disabled]="domainUpdateRetryLoading"
        [class.button--disabled]="domainUpdateRetryLoading"
        (click)="onDomainUpdateRetry()">
        {{content?.toastMessageList[0]?.CTAText || 'Try Again'}}
        <mat-spinner *ngIf="domainUpdateRetryLoading" diameter="16" class="btn-inline-spinner"></mat-spinner>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #contactSupportTemplate>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{content?.['b2b.managecompany.domainupdatefailed'] || 'Domain update failed'}}</span>
      <mat-icon
        fontSet="material-symbols-outlined"
        class="close_icon"
        tabindex="0"
        role="button"
        aria-label="close button"
        (keyup.space)="closeContactSupportPopup()"
        (keydown.enter)="closeContactSupportPopup()"
        (click)="closeContactSupportPopup()">
        close
      </mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <p>{{content?.['b2b.managecompany.domainupdatecontactsupport'] || 'The domain update could not be completed. Please contact support for assistance.'}}</p>
    </div>
    <div class="custom-popup-gen-footer">
      <button class="button--primary-small" mat-button type="button" (click)="closeContactSupportPopup()">
        {{ content?.warningList?.[6]?.confirmCTAText }}
      </button>
    </div>
  </div>
</ng-template>
